import { isNotLoggedIn } from 'utils/auth'
import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'auto-login-redirect/:jwt/:dashboardUrl',
  isPrintView: true,
  onEnter: isNotLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      const AutoLoginRedirect = require('./containers/AutoLoginRedirect').default
      const reducer = require('./modules/auto-login-redirect').default

      injectReducer(store, {key: 'loginState', reducer: reducer})
      /*  Return getComponent   */
      cb(null, AutoLoginRedirect)

      /* Webpack named bundle   */
    }, 'AutoLoginRedirect')
  }
})



// WEBPACK FOOTER //
// ./src/routes/AutoLoginRedirect/index.js